export const HOST_URL = process.env.REACT_APP_HOST_URL;
export const CLASSTING_URL = process.env.REACT_APP_CLASSTING_URL;
export const CLASSTING_API_URL = process.env.REACT_APP_CLASSTING_API_URL;
export const PAGE_LOG_URL = process.env.REACT_APP_PAGE_LOG_URL;
export const EVENT_LOG_URL = process.env.REACT_APP_EVENT_LOG_URL;
export const API_LOG_URL = process.env.REACT_APP_API_LOG_URL;
export const FIREBASE_AUTH_BASE_URL = process.env.REACT_APP_FIREBASE_AUTH_BASE_URL;
